module.exports = __webpack_public_path__ + "img/BillerKH.8dfb1cb3.png";